import React from 'react';
import PropTypes from 'prop-types';
import Button from 'jsx/elements/buttons/Button';

const ButtonSave = ({onClick}) => {   
    return (
        <Button text="Vista" color="gray" iconright="true" onClick={onClick}></Button> 
      );
};

ButtonSave.propTypes = {
  onClick: PropTypes.func,
};
 
export default ButtonSave;
